/*
 * BEAHATER CDP — Onsite Tracking Snippet
 * Version: 1.0  (2026-04-30)
 *
 * Sendet Events an n8n: page_view, view_product, view_collection, add_to_cart,
 * remove_from_cart, search, checkout_start, newsletter_signup.
 *
 * Identity:
 *   - Logged-in Customer: window.BEAHATER_CDP_BOOT.customer_email + customer_id
 *   - Anonym: session_id (UUID, 30d localStorage)
 *
 * Consent:
 *   - window.BEAHATER_CDP_BOOT.consent = { marketing, analytics, ads }
 *   - Falls fehlend: false / false / false (nur Funktionsdaten, kein Tracking)
 *
 * Public API:
 *   window.beahaterCDP.track(eventType, payload)
 *   window.beahaterCDP.trackAddToCart(productId, qty, value)
 *   window.beahaterCDP.trackRemoveFromCart(productId)
 *   window.beahaterCDP.trackSearch(query)
 *   window.beahaterCDP.trackProductView(productId, value, props)
 */
(function () {
  'use strict';

  var ENDPOINT = 'https://n8n.beahater.de/webhook/track/event';
  var STORAGE_KEY = 'beahater_cdp_session';
  var SESSION_TTL_MS = 30 * 24 * 60 * 60 * 1000; // 30d
  var META_PIXEL_ID = '1068292551220414';

  // === Meta Pixel Loader (v1.2 - 2026-05-09) ===
  // Lädt fbevents.js im MAIN window (NICHT im Customer-Events-Sandbox).
  // Folge: _fbp/_fbc Cookies werden auf der Haupt-Domain gesetzt → CAPI Match Quality.
  // KEIN Auto-PageView (das macht der Custom Pixel im Sandbox bereits).
  try {
    if (!window.fbq) {
      (function(f,b,e,v,n,t,s){
        n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;
        n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];
        t=b.createElement(e);t.async=!0;t.src=v;
        s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s);
      })(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');
      window.fbq('init', META_PIXEL_ID);
      // Bewusst kein 'PageView' track hier — Custom Pixel im Sandbox macht das.
      // Der init-Call reicht damit fbevents.js _fbp Cookie setzt.
    }
  } catch (_) {}

  // === Meta Pixel Match-Quality Helpers (v1.1 - 2026-05-09) ===
  // Liest _fbp / _fbc Cookies vom Browser und schickt sie an Server-Side CAPI
  // damit Meta Browser-Pixel + Server-Event matchen kann.
  function readCookie(name) {
    try {
      var m = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/[.$?*|{}()[\]\\\/+^]/g, '\\$&') + '=([^;]*)'));
      return m ? decodeURIComponent(m[1]) : null;
    } catch (_) { return null; }
  }
  function buildFbcFromUrl() {
    // Falls Cookie noch nicht da: fbclid aus URL → persistiere als _fbc
    try {
      var u = new URL(window.location.href);
      var fbclid = u.searchParams.get('fbclid');
      if (!fbclid) return null;
      var fbc = 'fb.1.' + Date.now() + '.' + fbclid;
      // 90d Cookie schreiben (Domain auto)
      document.cookie = '_fbc=' + fbc + '; path=/; max-age=' + (90 * 24 * 3600) + '; SameSite=Lax';
      return fbc;
    } catch (_) { return null; }
  }
  function getFbp() { return readCookie('_fbp'); }
  function getFbc() { return readCookie('_fbc') || buildFbcFromUrl(); }

  // Meta Pixel Mapping für event_id Deduplication (Pixel + Server gleicher ID)
  var META_EVENT_MAP = {
    'view_product':    'ViewContent',
    'view_collection': 'ViewCategory',
    'add_to_cart':     'AddToCart',
    'search':          'Search',
    'checkout_start':  'InitiateCheckout',
    'newsletter_signup': 'Lead'
  };

  function generateEventId(eventType, sessionId, productId) {
    return eventType + '_' + (sessionId || 'anon') + '_' + Date.now() + '_' + (productId || 'na');
  }

  var BOOT = window.BEAHATER_CDP_BOOT || {};
  var CONSENT = BOOT.consent || { marketing: false, analytics: false, ads: false };

  // Wenn weder analytics noch ads consent: kein Tracking. Nur funktionale Identity.
  // Recovery-relevante Events (add_to_cart, checkout_start) gehen trotzdem durch
  // weil sie Vertragsanbahnung sind — nicht Tracking. Marketing-Consent steuert
  // späteren Mailversand, nicht das Event-Logging.

  function uuid() {
    return ('xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx').replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0;
      var v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  function getSession() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (raw) {
        var obj = JSON.parse(raw);
        if (obj && obj.id && obj.expires_at && obj.expires_at > Date.now()) return obj.id;
      }
    } catch (_) {}
    var id = uuid();
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({ id: id, expires_at: Date.now() + SESSION_TTL_MS }));
    } catch (_) {}
    return id;
  }

  function getUtms() {
    try {
      var u = new URL(window.location.href);
      var p = u.searchParams;
      var v = {
        utm_source: p.get('utm_source'),
        utm_medium: p.get('utm_medium'),
        utm_campaign: p.get('utm_campaign')
      };
      // 30d-Sticky
      if (v.utm_source || v.utm_medium || v.utm_campaign) {
        try { localStorage.setItem('beahater_cdp_utm', JSON.stringify({ v: v, expires_at: Date.now() + SESSION_TTL_MS })); } catch (_) {}
        return v;
      }
      var raw = localStorage.getItem('beahater_cdp_utm');
      if (raw) {
        var stored = JSON.parse(raw);
        if (stored && stored.expires_at > Date.now()) return stored.v || {};
      }
    } catch (_) {}
    return {};
  }

  // === IDENTIFIED-EMAIL-STORE (v1.5 - 2026-05-11): EMQ-Boost ===
  // Wenn der Nutzer sich via Newsletter/Popup/Form identifiziert, speichern wir
  // die Email-Adresse für 90 Tage im localStorage. Dann hat JEDER nachfolgende Event
  // (ViewContent, AddToCart, Search) die Email als Match-Signal → Meta erkennt User.
  var EMAIL_KEY = 'beahater_cdp_email';
  var EMAIL_TTL_MS = 90 * 24 * 60 * 60 * 1000;
  function setStoredEmail(email) {
    if (!email || typeof email !== 'string') return;
    var clean = email.trim().toLowerCase();
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(clean)) return; // einfache Validierung
    try {
      localStorage.setItem(EMAIL_KEY, JSON.stringify({ v: clean, exp: Date.now() + EMAIL_TTL_MS }));
    } catch (_) {}
  }
  function getStoredEmail() {
    try {
      var raw = localStorage.getItem(EMAIL_KEY);
      if (!raw) return null;
      var p = JSON.parse(raw);
      if (!p || !p.exp || p.exp < Date.now()) {
        try { localStorage.removeItem(EMAIL_KEY); } catch (_) {}
        return null;
      }
      return p.v || null;
    } catch (_) { return null; }
  }

  // === IDEMPOTENCY-CACHE (v1.4 - 2026-05-11): blockt Doppel-Send innerhalb 2s ===
  var SEND_DEDUP_CACHE = {};
  var SEND_DEDUP_MS = 2000;
  function isDuplicate(eventType, productId, sessionId) {
    var key = eventType + '|' + (productId || '') + '|' + sessionId;
    var now = Date.now();
    var last = SEND_DEDUP_CACHE[key];
    SEND_DEDUP_CACHE[key] = now;
    return last && (now - last) < SEND_DEDUP_MS;
  }

  function send(eventType, payload) {
      payload = payload || {};

      // event_id generieren (wird vom Server-CAPI als event_id genutzt)
      var sessionId = (typeof getSessionId === 'function') ? getSessionId() :
                      (BOOT.session_id || (Math.random().toString(36).slice(2)));

      // Doppel-Send blocken (selber Event innerhalb 2s)
      if (isDuplicate(eventType, payload.product_id, sessionId)) return;

      var eventId = generateEventId(eventType, sessionId, payload.product_id);
      payload.event_id = eventId;

      // Server-Side-Call (an n8n) — EINZIGE Quelle die zu Meta sendet (v1.4 - 2026-05-11)
      // Browser-fbq('track')-Block entfernt: nur Server-Side ist verbindlich.
      // fbq('init') (oben) bleibt, damit der _fbp-Cookie für Match Quality gesetzt wird.
    try {
      var utms = getUtms();
      var fbp = getFbp();
      var fbc = getFbc();
      // v1.5 (2026-05-11): mehr User-Daten für EMQ (Match Quality)
      // Email-Reihenfolge: BOOT.customer_email (Login) > localStorage (vorher identifiziert) > null
      var identifiedEmail = BOOT.customer_email || getStoredEmail() || null;
      var body = {
        event_type: eventType,
        event_id: eventId,
        session_id: getSession(),
        email: identifiedEmail,
        ts: Date.now(),
        marketing_consent: !!CONSENT.marketing,
        analytics_consent: !!CONSENT.analytics,
        ads_consent: !!CONSENT.ads,
        utm_source: utms.utm_source || null,
        utm_medium: utms.utm_medium || null,
        utm_campaign: utms.utm_campaign || null,
        fbp: fbp || null,
        fbc: fbc || null,
        // EMQ-Boost: Customer-Daten bei eingeloggten Kunden (von cdp-tracking-boot.liquid)
        first_name: BOOT.customer_first_name || null,
        last_name: BOOT.customer_last_name || null,
        phone: BOOT.customer_phone || null,
        city: BOOT.customer_city || null,
        zip: BOOT.customer_zip || null,
        state: BOOT.customer_state || null,
        country: BOOT.customer_country || null
      };
      // payload: { product_id, value, currency, properties }
      if (payload) {
        if (payload.product_id) body.product_id = String(payload.product_id);
        if (payload.value != null) body.value = payload.value;
        if (payload.currency) body.currency = payload.currency;
        if (payload.properties) body.properties = payload.properties;
      }

      // Primary: fetch mit keepalive (überlebt Navigation, sieht echte CORS-Errors)
      // Fallback: sendBeacon nur wenn fetch nicht verfügbar (uralt-Browser oder
      // explizit pagehide-Event)
      var json = JSON.stringify(body);
      if (window.fetch) {
        fetch(ENDPOINT, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: json,
          keepalive: true,
          credentials: 'omit',
          mode: 'cors'
        }).catch(function () {});
      } else if (navigator.sendBeacon) {
        navigator.sendBeacon(ENDPOINT, new Blob([json], { type: 'application/json' }));
      }
    } catch (e) {
      // tolerant — Tracking darf nie die Seite brechen
    }
  }

  var api = {
    track: send,
    trackProductView: function (productId, value, props) { send('view_product', { product_id: productId, value: value, properties: props || {} }); },
    trackCollectionView: function (handle, props) { send('view_collection', { properties: Object.assign({ handle: handle }, props || {}) }); },
    trackAddToCart: function (productId, qty, value) { send('add_to_cart', { product_id: productId, value: value, properties: { quantity: qty || 1 } }); },
    trackRemoveFromCart: function (productId, qty) { send('remove_from_cart', { product_id: productId, properties: { quantity: qty || 1 } }); },
    trackSearch: function (query, results) { send('search', { properties: { query: query, results_count: results } }); },
    trackCheckoutStart: function (value) { send('checkout_start', { value: value }); },
    trackNewsletterSignup: function (props) { send('newsletter_signup', { properties: props || {} }); },
    // v1.5 (2026-05-11): explizite Identifikation, z.B. nach Newsletter-Anmeldung
    identify: function (email) { setStoredEmail(email); }
  };
  window.beahaterCDP = api;

  // v1.5 (2026-05-11): Auto-Capture aller Email-Inputs bei Form-Submit
  // Wenn ein Form abgeschickt wird und ein input[type=email] mit gültigem Wert drin ist,
  // speichern wir die Email für 90 Tage. So bekommt JEDER nachfolgende Event eine Email.
  try {
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || form.tagName !== 'FORM') return;
      var emailInput = form.querySelector('input[type="email"], input[name="email"], input[name*="EMAIL"]');
      if (emailInput && emailInput.value) setStoredEmail(emailInput.value);
    }, true);
  } catch (_) {}

  // 1. AUTO: page_view auf jedem Load
  send('page_view', { properties: { path: location.pathname, title: document.title } });

  // 2. AUTO: view_product / view_collection wenn das Theme-Boot es mitgibt
  if (BOOT.product && BOOT.product.id) {
    api.trackProductView(BOOT.product.id, BOOT.product.price, {
      title: BOOT.product.title,
      handle: BOOT.product.handle,
      vendor: BOOT.product.vendor
    });
  }
  if (BOOT.collection && BOOT.collection.handle) {
    api.trackCollectionView(BOOT.collection.handle, { title: BOOT.collection.title });
  }

  // 3. AUTO: Hook auf Shopify Cart fetch-Calls (/cart/add.js, /cart/change.js)
  try {
    var origFetch = window.fetch;
    if (origFetch) {
      window.fetch = function (input, init) {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        var promise = origFetch.apply(this, arguments);
        if (/\/cart\/add(\.js)?(\?|$)/.test(url)) {
          promise.then(function (r) {
            r.clone().json().then(function (j) {
              // Shopify ATC response enthält das hinzugefügte Item
              var items = Array.isArray(j) ? j : (j && j.items) || [j];
              items.forEach(function (it) {
                if (it && it.product_id) {
                  api.trackAddToCart(it.product_id, it.quantity || 1, (it.final_price || it.price) ? (it.final_price || it.price) / 100 : null);
                }
              });
            }).catch(function () {});
          }).catch(function () {});
        } else if (/\/cart\/change(\.js)?(\?|$)/.test(url) && init && init.body) {
          // remove = quantity 0
          try {
            var bodyText = typeof init.body === 'string' ? init.body : '';
            if (bodyText && /quantity=0|"quantity":\s*0/.test(bodyText)) {
              var idMatch = bodyText.match(/(?:id|line)=([^&]+)/) || bodyText.match(/"id"\s*:\s*"?([^",]+)/);
              if (idMatch) api.trackRemoveFromCart(idMatch[1]);
            }
          } catch (_) {}
        }
        return promise;
      };
    }
  } catch (_) {}

  // 4. ENTFERNT (v1.4 - 2026-05-11): Form-Submit-Listener war redundant zum fetch-Hook (Block 3).
  //    Beide haben bei selbem Klick gefeuert → Doppel-AddToCart in events-Tabelle.
  //    Theme nutzt /cart/add.js AJAX, Block 3 catched alle Adds zuverlässig.

  // 5. AUTO: Search-Form
  try {
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || form.tagName !== 'FORM') return;
      var action = (form.getAttribute('action') || '').toLowerCase();
      if (/\/search$/.test(action)) {
        var q = form.querySelector('input[name="q"]');
        if (q && q.value) api.trackSearch(q.value);
      }
    }, true);
  } catch (_) {}

  // === v1.3 EXTENDED EVENTS (2026-05-09) ===

  // 7. AUTO: Scroll-Tiefe (25/50/75/100%) — Engagement-Signal, je Page nur 1x pro Marke
  try {
    var scrollFiredMarks = {};
    var scrollMarks = [25, 50, 75, 100];
    function checkScroll() {
      try {
        var doc = document.documentElement;
        var scrollY = window.pageYOffset || doc.scrollTop;
        var height = (doc.scrollHeight || document.body.scrollHeight) - window.innerHeight;
        if (height <= 0) return;
        var pct = Math.round((scrollY / height) * 100);
        for (var i = 0; i < scrollMarks.length; i++) {
          var m = scrollMarks[i];
          if (pct >= m && !scrollFiredMarks[m]) {
            scrollFiredMarks[m] = true;
            send('scroll_depth', { properties: { depth: m, path: location.pathname } });
          }
        }
      } catch (_) {}
    }
    var scrollThrottle = null;
    window.addEventListener('scroll', function () {
      if (scrollThrottle) return;
      scrollThrottle = setTimeout(function () { checkScroll(); scrollThrottle = null; }, 200);
    }, { passive: true });
  } catch (_) {}

  // 8. AUTO: Time-on-Page Buckets (30s, 60s, 120s, 300s)
  try {
    var timeBuckets = [30, 60, 120, 300];
    timeBuckets.forEach(function (sec) {
      setTimeout(function () {
        if (!document.hidden) send('time_on_page', { properties: { seconds: sec, path: location.pathname } });
      }, sec * 1000);
    });
  } catch (_) {}

  // 9. AUTO: Variant-Wechsel (Größe/Farbe) auf Produktseite
  try {
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || t.tagName !== 'SELECT' && t.tagName !== 'INPUT') return;
      var name = (t.name || '').toLowerCase();
      var isVariant = name === 'id' || name.indexOf('option') >= 0 || /size|color|farbe|größe|groesse/.test(name);
      if (!isVariant) return;
      var label = (t.dataset && t.dataset.optionName) || t.closest('[data-option-name]')?.dataset?.optionName || name;
      var val = t.tagName === 'SELECT' ? (t.options[t.selectedIndex] || {}).text : t.value;
      send('variant_selected', {
        product_id: BOOT.product && BOOT.product.id,
        properties: { option: label, value: val, path: location.pathname }
      });
    }, true);
  } catch (_) {}

  // 10. AUTO: Wishlist Add — listen auf Custom Events / Klassen
  try {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest(
        '[data-wishlist-add], .wishlist-add, .add-to-wishlist, button[name="wishlist"], a[href*="wishlist"]'
      );
      if (!btn) return;
      var pid = btn.dataset.productId || btn.dataset.product || (BOOT.product && BOOT.product.id);
      send('wishlist_add', {
        product_id: pid,
        properties: { source: 'click', path: location.pathname }
      });
    }, true);
    // Custom Event API für Apps die Wishlist programmatisch dispatchen
    window.addEventListener('beahater:wishlist:add', function (e) {
      send('wishlist_add', { product_id: e.detail && e.detail.product_id, properties: e.detail || {} });
    });
  } catch (_) {}

  // 11. AUTO: Image-Zoom auf Produktseite (Klick auf Hauptbild oder Zoom-Trigger)
  try {
    var zoomFiredOnce = false;
    document.addEventListener('click', function (e) {
      if (zoomFiredOnce) return;
      var img = e.target.closest && e.target.closest(
        '.product__media img, .product-gallery img, [data-product-image], product-modal, .zoom-trigger'
      );
      if (!img) return;
      if (!BOOT.product || !BOOT.product.id) return;
      zoomFiredOnce = true;
      send('image_zoom', {
        product_id: BOOT.product.id,
        properties: { path: location.pathname }
      });
    }, true);
  } catch (_) {}

  // 12. AUTO: Info-Drawer öffnen (Care / Shipping / Size Guide) — Pre-Purchase-Recherche
  try {
    document.addEventListener('click', function (e) {
      var trig = e.target.closest && e.target.closest(
        '[data-info-drawer], .care-info-trigger, .shipping-info-trigger, .size-guide-trigger, ' +
        'a[href*="size-guide"], a[href*="pflege"], a[href*="versand"]'
      );
      if (!trig) return;
      var topic = trig.dataset.infoTopic ||
                  (trig.className.indexOf('care') >= 0 ? 'care' :
                   trig.className.indexOf('shipping') >= 0 ? 'shipping' :
                   trig.className.indexOf('size') >= 0 ? 'size_guide' : 'info');
      send('info_open', {
        product_id: BOOT.product && BOOT.product.id,
        properties: { topic: topic, path: location.pathname }
      });
    }, true);
  } catch (_) {}

  // 13. AUTO: Phone Capture — bei input on Phone-Feld (Newsletter/Account)
  try {
    document.addEventListener('blur', function (e) {
      var t = e.target;
      if (!t || (t.tagName !== 'INPUT' && t.tagName !== 'TEL')) return;
      var type = (t.type || '').toLowerCase();
      var name = (t.name || '').toLowerCase();
      if (type !== 'tel' && name.indexOf('phone') < 0) return;
      var v = (t.value || '').trim();
      if (v.length < 6) return;
      send('phone_capture', { properties: { source: 'form_blur', length: v.length } });
    }, true);
  } catch (_) {}

  // 6. AUTO: Checkout-Klick — zusätzlich fbp/fbc/UA in Cart-Attributes persistieren,
  //    damit der Server-Side Order-Webhook die Felder aus order.note_attributes lesen kann
  //    (Brücke vom Browser-Cookie zum Server-CAPI Purchase-Event)
  function persistMatchAttribsForCheckout() {
    try {
      var fbp = getFbp();
      var fbc = getFbc();
      var attribs = {
        '_fbp': fbp || '',
        '_fbc': fbc || '',
        '_user_agent': (navigator.userAgent || '').slice(0, 500),
        '_cdp_session': getSession()
      };
      // Shopify Cart-Update Attributes (idempotent)
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: attribs }),
        keepalive: true,
        credentials: 'same-origin'
      }).catch(function () {});
    } catch (_) {}
  }
  try {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('button[name="checkout"], a[href*="/checkouts/"], a[href$="/cart/checkout"]');
      if (btn) {
        persistMatchAttribsForCheckout();
        api.trackCheckoutStart();
      }
    }, true);
  } catch (_) {}

})();
